/* tslint:disable */
export enum Currency {
  Czk = 'CZK',
  Eur = 'EUR',
  Uah = 'UAH',
  Pln = 'PLN',
}
